import { useState, useEffect, useMemo, useRef } from 'react';

const STORAGE_KEY = 'akf_list_page_size';

export default function usePagination(items, filterKey = '') {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(() => {
    const saved = parseInt(localStorage.getItem(STORAGE_KEY), 10);
    return [25, 50, 100].includes(saved) ? saved : 50;
  });

  const prevKey = useRef(filterKey);
  useEffect(() => {
    if (prevKey.current !== filterKey) {
      prevKey.current = filterKey;
      setPage(1);
    }
  }, [filterKey]);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(pageSize));
  }, [pageSize]);

  const total = items.length;
  const maxPage = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(page, maxPage);

  const pageItems = useMemo(
    () => items.slice((safePage - 1) * pageSize, safePage * pageSize),
    [items, safePage, pageSize]
  );

  return {
    pageItems,
    total,
    page: safePage,
    pageSize,
    setPage,
    setPageSize,
    controlProps: {
      total,
      page: safePage,
      pageSize,
      onPageChange: setPage,
      onPageSizeChange: setPageSize,
    },
  };
}
